import { useChatStream } from '../../hooks/useChatStream';
import { Sidebar } from './Sidebar';
import { ChatPane } from './ChatPane';

export function ChatScreen({ onBack }: { onBack?: () => void }) {
  useChatStream();
  return (
    <div className="w-full h-[100dvh] overflow-hidden flex bg-white">
      <Sidebar />
      <ChatPane onBack={onBack} />
    </div>
  );
}
